<div class="grid" class="invoice-content" *ngIf="!utilService.doesURLHaveText('sales')">
  <div class="col-12">
    <div class="card py-2 px-6 md:px-8 overflow-auto">
      <div class="flex flex-row align-items-center justify-content-between border-bottom-1 surface-border pb-5 min-w-max">
        <div class="flex flex-column mr-6">
          <img *ngIf="organizationLogo" [src]="organizationLogo" alt="organization-logo" style="width: 16%; height: auto" />

          <div class="my-3 text-xl font-bold" *ngIf="organizationLogo">
            {{ organization?.name }}
          </div>
          <div class="my-3 text-4xl font-bold" *ngIf="!organizationLogo">
            {{ organization?.name }}
          </div>
          <span>{{ organization?.address }}</span>
          <span>{{ organization?.phoneNumber }}</span>
          <span>{{ organization?.email }}</span>
          <span>{{ organization?.website }}</span>
        </div>

        <div class="flex flex-column mt-5 md:mt-0">
          <div class="text-2xl font-semibold text-left md:text-right mb-3">
            {{ receiptType }}
          </div>
          <div class="flex flex-column">
            <div class="flex justify-content-between align-items-center mb-2">
              <span class="font-semibold mr-6">{{ receiptType }} #</span>
              <span>{{ receiptDetailsHeader?.transactionUniqueCode || receiptDetailsHeader?.transactionCode }}</span>
            </div>
            <div class="flex justify-content-between align-items-center mb-2">
              <span class="font-semibold mr-6">DATE</span>
              <span> {{ receiptDetailsHeader?.createdAt | date: 'mediumDate' }}</span>
            </div>
            <div class="flex justify-content-between align-items-center" *ngIf="receiptDetailsHeader?.transactionDueDate">
              <span class="font-semibold mr-6">DUE DATE</span>
              <span> {{ receiptDetailsHeader?.transactionDueDate | date: 'mediumDate' }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-5 mb-8 grid">
        <div class="col">
          <div class="mb-3 text-2xl font-medium">BILL TO</div>
          <span class="block mb-2">{{ receiptDetailsHeader?.customer?.name | titlecase }}</span>
          <span class="block">
            {{ receiptDetailsHeader?.customer?.address }}
          </span>
          <span class="block mb-1">
            {{ receiptDetailsHeader?.customer?.city }}
          </span>
          <span class="block mb-1" *ngIf="receiptDetailsHeader?.customer?.phoneNumber">
            Phone:
            {{ receiptDetailsHeader?.customer?.phoneNumber }}
          </span>
          <span class="block mb-1" *ngIf="receiptDetailsHeader?.customer?.email">
            Email Address:
            {{ receiptDetailsHeader?.customer?.email }}
          </span>
        </div>

        <div class="col">
          <div class="flex justify-content-end align-items-start">
            @if (stamp()) {
              <img [src]="stamp()" alt="organization-stamp" class="sign-stamp" />
            }
            @if (sign()) {
              <img [src]="sign()" alt="organization-sign" class="sign-stamp" />
            }
          </div>
        </div>
      </div>

      <div class="overflow-x-auto">
        <table class="w-full" style="border-collapse: collapse; table-layout: auto">
          <thead>
            <tr>
              <th class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap max-w-30rem">Name</th>
              <!-- <th
                                class="font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3"
                            >
                                Description
                            </th> -->
              <th class="text-left font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">Quantity</th>
              <th class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap px-3">Unit Price</th>
              <th class="text-right font-semibold py-3 border-bottom-1 surface-border white-space-nowrap">Line Total</th>
            </tr>
          </thead>
          <tbody *ngFor="let item of receiptLineItems">
            <tr [ngClass]="!item?.description ? 'border-bottom-1 surface-border' : null">
              <td class="text-left py-1 white-space-normal font-semibold max-w-28rem">
                {{ item?.name }}
              </td>
              <!-- <td class="py-1 px-3">
                                {{ item?.description }}
                            </td> -->
              <td class="text-center py-1 px-3">
                {{ item?.quantity }}
              </td>
              <td class="text-right py-1 px-3">
                {{
                  item?.convertedItemPrice
                    | currency
                      : (receiptDetailsHeader?.currency
                          ? receiptDetailsHeader?.currency?.symbol
                            ? receiptDetailsHeader?.currency?.symbol
                            : receiptDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}
              </td>
              <td class="text-right py-1">
                {{
                  item.convertedLineTotal
                    | currency
                      : (receiptDetailsHeader?.currency
                          ? receiptDetailsHeader?.currency?.symbol
                            ? receiptDetailsHeader?.currency?.symbol
                            : receiptDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}
              </td>
            </tr>
            <tr class="border-bottom-1 surface-border" *ngIf="item?.description">
              <td colspan="2" class="py-3">
                {{ item?.description }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="flex flex-wrap justify-content-end mt-5 pb-3">
        <div class="w-6 pl-0 pr-3 flex align-items-end mt-0">
          <ul class="list-none p-0 m-0 w-full">
            <li class="flex justify-content-between mb-3">
              <span class="">Subtotal</span
              ><span class="font-medium text-lg">
                {{
                  receiptDetailsHeader?.convertedTransactionTotalAmount
                    | currency
                      : (receiptDetailsHeader?.currency
                          ? receiptDetailsHeader?.currency?.symbol
                            ? receiptDetailsHeader?.currency?.symbol
                            : receiptDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}</span
              >
            </li>
            @if (receiptDetailsHeader?.discount?.amount || receiptDetailsHeader?.discount?.percentage) {
              <li class="flex justify-content-between mb-3">
                <span class="text-green-600"
                  >{{ receiptDetailsHeader?.discount?.description ? receiptDetailsHeader?.discount?.description : 'Discount' }}
                  @if (receiptDetailsHeader?.discount?.percentage) {
                    ({{ receiptDetailsHeader?.discount?.percentage }}%)
                  }</span
                ><span class="text-900 font-medium text-lg">{{
                  receiptDetailsHeader?.discount?.amount
                    | currency
                      : (receiptDetailsHeader?.currency
                          ? receiptDetailsHeader?.currency?.symbol
                            ? receiptDetailsHeader?.currency?.symbol
                            : receiptDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}</span>
              </li>
            }
            <li class="flex justify-content-between mb-3 border-top-1 surface-border pt-3">
              <span class="text-900 font-medium">Total (Excl. of Tax)</span
              ><span class="text-900 font-medium text-lg">
                {{
                  receiptDetailsHeader?.convertedTransactionTotalAmount
                    | currency
                      : (receiptDetailsHeader?.currency
                          ? receiptDetailsHeader?.currency?.symbol
                            ? receiptDetailsHeader?.currency?.symbol
                            : receiptDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}</span
              >
            </li>
            <li class="flex justify-content-between mb-3" *ngFor="let tax of receiptDetailsHeader?.totalTaxes">
              <span class="text-900">{{ tax.name }} {{ tax.percentage }}%</span
              ><span class="text-900 font-medium text-lg">{{
                tax.convertedAmount
                  | currency
                    : (receiptDetailsHeader?.currency
                        ? receiptDetailsHeader?.currency?.symbol
                          ? receiptDetailsHeader?.currency?.symbol
                          : receiptDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}</span>
            </li>
            <li class="flex justify-content-between border-top-1 surface-border py-3">
              <span class="text-900 font-bold text-lg">Total</span
              ><span class="text-900 font-medium text-lg">{{
                receiptDetailsHeader?.convertedAmount
                  | currency
                    : (receiptDetailsHeader?.currency
                        ? receiptDetailsHeader?.currency?.symbol
                          ? receiptDetailsHeader?.currency?.symbol
                          : receiptDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}</span>
            </li>
            <span *ngFor="let paymentRecord of receiptPaymentRecords">
              <li class="flex justify-content-between mb-3">
                <span class="text-900">Payment on {{ paymentRecord.createdAt | date }} using {{ paymentRecord.paymentTerm }}: </span
                ><span class="text-900 font-medium text-lg">{{
                  paymentRecord.amount
                    | currency
                      : (receiptDetailsHeader?.currency
                          ? receiptDetailsHeader?.currency?.symbol
                            ? receiptDetailsHeader?.currency?.symbol
                            : receiptDetailsHeader?.currency?.code
                          : utilService.getCurrentCurrency())
                }}</span>
              </li>
            </span>
            <li
              class="flex justify-content-between border-top-1 surface-border py-3"
              *ngIf="receiptDetailsHeader?.transactionBalance && utilService.doesURLHaveText('invoices')"
            >
              <span class="text-900 font-bold">Amount Due</span
              ><span class="text-900 font-bold text-lg">{{
                receiptDetailsHeader?.convertedTransactionBalance
                  | currency
                    : (receiptDetailsHeader?.currency
                        ? receiptDetailsHeader?.currency?.symbol
                          ? receiptDetailsHeader?.currency?.symbol
                          : receiptDetailsHeader?.currency?.code
                        : utilService.getCurrentCurrency())
              }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex flex-wrap justify-content-start mt-2 pb-3" *ngIf="organization?.printoutSettings?.invoice?.privacyPolicy">
        <div>
          <h6>Notes/Terms</h6>
          <div [innerHTML]="organization?.printoutSettings?.invoice?.privacyPolicy" class="w-full"></div>
          <div class="mt-2">
            {{ receiptDetailsHeader?.customerNotes }}
          </div>
        </div>
      </div>
      <div class="flex align-content-center justify-content-center border-top-1 surface-border pt-4 text-center receipt-footer">
        {{ organization?.printoutSettings?.invoice?.tagline ? organization?.printoutSettings?.invoice?.tagline : 'Thank you for your business' }}
      </div>
      <div>
        <app-receipt-footer [printingView]="true"></app-receipt-footer>
      </div>
    </div>
  </div>
</div>

<div class="receipt-content" *ngIf="utilService.doesURLHaveText('sales')">
  <div class="store-details text-center">
    @if (organizationLogo) {
      <p-avatar size="large" class="invoice-avatar flex justify-content-center my-4">
        <img [src]="organizationLogo" alt="organization-logo" />
      </p-avatar>
      <h3 class="my-1 text-xl font-bold">
        {{ organization?.name }}
      </h3>
    } @else {
      <h4 class="my-3 text-4xl font-bold">
        {{ organization?.name }}
      </h4>
    }

    <div class="flex flex-column">
      <span>{{ organization?.address }}</span>
      <span>{{ organization?.phoneNumber }}</span>
      <span>{{ organization?.email }}</span>
      <span>{{ organization?.website }}</span>
    </div>
  </div>

  <div class="receipt-section">
    <h5>Receipt</h5>
    <p class="mb-0">Date: {{ receiptDetailsHeader?.createdAt | date: 'mediumDate' }}</p>
    <p class="mb-4">
      Receipt #:
      {{ receiptDetailsHeader?.transactionUniqueCode || receiptDetailsHeader?.transactionCode }}
    </p>
  </div>

  <div class="receipt-section">
    <table class="receipt-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Qty</th>
          <th>Price</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody *ngFor="let item of receiptLineItems">
        <tr [ngClass]="!item?.description ? 'border-bottom-1 surface-border' : null">
          <td class="text-left py-3">
            {{ item?.name }}
          </td>
          <td class="text-right py-3 px-3">
            {{ item?.quantity }}
          </td>
          <td class="text-right py-3 px-3">
            {{
              item?.itemPrice
                | currency
                  : (receiptDetailsHeader?.currency
                      ? receiptDetailsHeader?.currency?.symbol
                        ? receiptDetailsHeader?.currency?.symbol
                        : receiptDetailsHeader?.currency?.code
                      : utilService.getCurrentCurrency())
            }}
          </td>
          <td class="text-right py-3">
            {{
              item.quantity * item.itemPrice
                | currency
                  : (receiptDetailsHeader?.currency
                      ? receiptDetailsHeader?.currency?.symbol
                        ? receiptDetailsHeader?.currency?.symbol
                        : receiptDetailsHeader?.currency?.code
                      : utilService.getCurrentCurrency())
            }}
          </td>
        </tr>
        <tr class="border-bottom-1 surface-border" *ngIf="item?.description">
          <td colspan="3" class="py-1 pl-2">
            {{ item?.description }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="receipt-section totals">
    <ul>
      <li>
        Subtotal:
        <span>
          {{
            receiptDetailsHeader?.transactionTotalAmount
              | currency
                : (receiptDetailsHeader?.currency
                    ? receiptDetailsHeader?.currency?.symbol
                      ? receiptDetailsHeader?.currency?.symbol
                      : receiptDetailsHeader?.currency?.code
                    : utilService.getCurrentCurrency())
          }}</span
        >
      </li>
      <li class="flex justify-content-between mb-3" *ngFor="let tax of receiptDetailsHeader?.totalTaxes">
        <span class="text-900">{{ tax.name }} {{ tax.percentage }}%</span
        ><span class="text-900 font-medium text-lg">{{
          tax.amount
            | currency
              : (receiptDetailsHeader?.currency
                  ? receiptDetailsHeader?.currency?.symbol
                    ? receiptDetailsHeader?.currency?.symbol
                    : receiptDetailsHeader?.currency?.code
                  : utilService.getCurrentCurrency())
        }}</span>
      </li>
      <li>
        Total:
        <span>{{
          receiptDetailsHeader?.transactionTotalamountWithtax
            | currency
              : (receiptDetailsHeader?.currency
                  ? receiptDetailsHeader?.currency?.symbol
                    ? receiptDetailsHeader?.currency?.symbol
                    : receiptDetailsHeader?.currency?.code
                  : utilService.getCurrentCurrency())
        }}</span>
      </li>
      <span *ngFor="let paymentRecord of receiptPaymentRecords">
        <li class="flex justify-content-between">
          Payment:
          <span>{{
            paymentRecord.amount
              | currency
                : (receiptDetailsHeader?.currency
                    ? receiptDetailsHeader?.currency?.symbol
                      ? receiptDetailsHeader?.currency?.symbol
                      : receiptDetailsHeader?.currency?.code
                    : utilService.getCurrentCurrency())
          }}</span>
        </li>
      </span>
      <li>
        Amount Due:
        <span>{{
          receiptDetailsHeader?.transactionBalance
            | currency
              : (receiptDetailsHeader?.currency
                  ? receiptDetailsHeader?.currency?.symbol
                    ? receiptDetailsHeader?.currency?.symbol
                    : receiptDetailsHeader?.currency?.code
                  : utilService.getCurrentCurrency())
        }}</span>
      </li>
    </ul>
  </div>

  <div class="receipt-section text-center">
    <p class="border-top-1 surface-border mt-4 pt-2">
      {{ organization?.printoutSettings?.receipt?.tagline ? organization?.printoutSettings?.receipt?.tagline : 'Thank you for your business' }}
    </p>
  </div>
</div>
